import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "installer container-fluid" }
const _hoisted_2 = { class: "card mx-auto" }
const _hoisted_3 = { class: "card-body text-center" }
const _hoisted_4 = { class: "h4" }
const _hoisted_5 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "sensors" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  class: "footnote"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.aggregatorName), 1),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.status !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", {
                class: _normalizeClass(["connection", _ctx.status.Connected ? 'online' : 'offline'])
              }, [
                _createVNode(_component_vue_feather, {
                  type: _ctx.status.Connected ? 'wifi' : 'wifi-off',
                  size: "42px"
                }, null, 8, ["type"]),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.status.Connected ? "Connected" : "Not connected"), 1)
              ], 2),
              _createElementVNode("p", _hoisted_7, [
                _cache[1] || (_cache[1] = _createTextVNode(" Sensors reporting (last 20 min): ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.status.SensorsReporting), 1)
              ]),
              (!_ctx.status.Connected)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Not receiving data. This page updates automatically."))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Checking…"))
            : _createCommentVNode("", true),
        (_ctx.lastChecked !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Last checked " + _toDisplayString(_ctx.lastChecked.toLocaleTimeString()), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}